import { render, staticRenderFns } from "./Albuns.vue?vue&type=template&id=47046ccd&"
import script from "./Albuns.vue?vue&type=script&lang=js&"
export * from "./Albuns.vue?vue&type=script&lang=js&"
import style0 from "./Albuns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports